import React, { useState } from 'react';
import { Avatar, Menu, MenuItem, IconButton } from '@mui/material';
import { useNavigate } from 'react-router-dom';
import { useDispatch } from 'react-redux';
import { resetState } from '../../Store/mainSlice';
import { clearAuthSession } from '../../_util/session';
import { styled } from '@mui/material/styles';

const StyledMenu = styled(Menu)({
    '& .MuiPaper-root': {
        minWidth: 180,
    },
});

const StyledMenuItem = styled(MenuItem)({
    '&:hover': {
        backgroundColor: '#dff0d8',
        color: '#4caf50',
    },
});

const ProfileDropdown = () => {
    const [anchorEl, setAnchorEl] = useState(null);
    const navigate = useNavigate();
    const dispatch = useDispatch();

    const handleMenuOpen = (event) => {
        setAnchorEl(event.currentTarget);
    };

    const handleMenuClose = () => {
        setAnchorEl(null);
    };

    const handleEditProfile = () => {
        navigate('edit-profile');
        handleMenuClose();
    };

    const handleForgetPassword = () => {
        navigate('change-password');
        handleMenuClose();
    };

    const handleLogout = () => {
        clearAuthSession();
        dispatch(resetState());
        navigate('/');
    };

    return (
        <div>
            <IconButton onClick={handleMenuOpen}>
                <Avatar />
            </IconButton>
            <StyledMenu
                anchorEl={anchorEl}
                open={Boolean(anchorEl)}
                onClose={handleMenuClose}
            >   
                <StyledMenuItem onClick={handleEditProfile}>Edit Profile</StyledMenuItem>
                <StyledMenuItem onClick={handleForgetPassword}>Change Password</StyledMenuItem>
                <StyledMenuItem onClick={handleLogout}>Logout</StyledMenuItem>
            </StyledMenu>
        </div>
    );
};

export default ProfileDropdown;
